<template>
  <el-card>
    <el-form ref="searchForm" :model="searchForm" class="global-form" :inline="true">
      <el-form-item>
        <el-select v-model="searchForm.projectId" clearable placeholder="项目名称">
          <el-option v-for="item in projectList" :key="item.projectId" :label="item.projectName" :value="item.projectId"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" class="medium" @click="onSearch">查询</el-button>
      </el-form-item>
    </el-form>
    <div class="mb20">
      <el-button type="primary" icon="el-icon-plus" @click="onAdd">新增</el-button>
    </div>
    <el-table ref="table" class="global-table" stripe v-loading="loading" :data="tableData" max-height="550px">
      <el-table-column label="项目名称" prop="projectName" show-overflow-tooltip></el-table-column>
      <el-table-column label="养护合同" prop="contractName" show-overflow-tooltip></el-table-column>
      <el-table-column label="开始日期" prop="startDate" show-overflow-tooltip></el-table-column>
      <el-table-column label="结束日期" prop="endDate" show-overflow-tooltip></el-table-column>
      <el-table-column label="合同总额（元）" prop="contractAmount" show-overflow-tooltip></el-table-column>
      <el-table-column label="操作" width="180px" fixed="right">
        <template v-slot="{ row }">
          <el-button type="text"
            @click="$router.push('/costplanning/details?planCostId=' + row.planCostId)">查看</el-button>
          <el-button type="text" @click="onDelete(row.planCostId)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <global-pagination :total="total" :current-page.sync="page" :page-size.sync="size" @current-change="loadData"
      @size-change="loadData"></global-pagination>

    <el-dialog :visible.sync="dialogVisible" title="成本计划">
      <el-form class="global-form2" :model="formData" ref="form" :rules="rules" label-width="120px">
        <el-form-item label="项目名称" prop="projectId">
          <el-select v-model="formData.projectId" placeholder="请选择所属项目" @change="projectChange">
            <el-option v-for="item in projectList" :key="item.projectId" :label="item.projectName"
              :value="item.projectId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="养护合同" prop="contractId">
          <el-select v-model="formData.contractId" placeholder="请选择养护合同" @change="contractChange">
            <el-option v-for="(item, index) in yhContractList" :key="index" :label="item.contractName"
              :value="item.contractId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="startDate" label="开始日期">
          <el-date-picker disabled v-model="formData.startDate" value-format="yyyy-MM-dd" type="date"
            placeholder="请选择开始日期"></el-date-picker>
        </el-form-item>
        <el-form-item prop="endDate" label="结束日期">
          <el-date-picker disabled v-model="formData.endDate" value-format="yyyy-MM-dd" type="date"
            placeholder="请选择结束日期"></el-date-picker>
        </el-form-item>
        <el-form-item prop="contractAmount" label="合同总额">
          <el-input disabled v-model="formData.contractAmount" placeholder="请输入合同总额"></el-input> 元
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">提交</el-button>
          <el-button @click="dialogVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </el-card>
</template>

<script>
export default {
  name: "CostPlanning",
  data() {
    return {
      page: 1,
      size: 10,
      total: 0,
      loading: false,
      tableData: [],
      searchForm: {
        projectId: ''
      },
      formData: {
        projectId: '',
        contractId: '',
        startDate: '',// 劳务开始日期
        endDate: '',// 劳务结束日期
        contractAmount: '' // 合同金额
      },
      rules: {
        projectId: [
          { required: true, message: '请选择项目名称' }
        ],
        contractId: [
          { required: true, message: '请选择养护合同' }
        ]
      },
      yhContractList: [],
      dialogVisible: false
    }
  },
  computed: {
    projectList() {
      return this.$store.state.projectList
    }
  },
  watch: {},
  created() {
    this.loadData()
  },
  methods: {
    loadData() {
      this.loading = true
      this.$axios.get(this.$apis.operate.selectPlanCostByPage, {
        page: this.page,
        size: this.size,
        ...this.searchForm,
      }).then((res) => {
        this.total = res.total || 0
        this.tableData = res.list || []
      }).finally(() => {
        this.loading = false
      })
    },
    onSearch() {
      this.page = 1
      this.loadData()
    },
    projectChange(val) {
      this.$axios.get(this.$apis.operate.selectContractList, {
        projectId: val
      }).then((res) => {
        this.yhContractList = res || []
      })
    },
    contractChange(val) {
      const data = this.yhContractList.find(item => item.contractId === val)
      this.formData.startDate = data.startDate
      this.formData.endDate = data.endDate
      this.formData.contractAmount = data.contractAmount || ''
    },
    onAdd() {
      this.formData = {
        projectId: '',
        contractId: '',
        startDate: '',
        endDate: '',
        contractAmount: ''
      }
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.form.resetFields()
      })
    },
    onDelete(planCostId) {
      this.$confirm('确认删除吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.operate.deletePlanCost, { planCostId }).then(() => {
          this.$message.success('删除成功')
          this.onSearch()
        })
      })
    },
    onSubmit() {
      this.$refs.form.validate().then(() => {
        this.$axios.post(this.$apis.operate.insertPlanCost, {
          contractId: this.formData.contractId
        }).then(() => {
          this.$message.success('提交成功')
          this.dialogVisible = false
          this.onSearch()
        })
      })
    }
  }
}
</script>

<style scoped lang="scss"></style>
